import { connect } from "react-redux";
import DonutForecast from "../../../global/donutForecast/donutForecastModule";
import { getGoalValue, getForecastValue } from "../../../../modules/goals/goalsModule";

export default connect(state => ({
  title: "MOST LIKELY TO SUCCEED",
  metricTitle: state.goalsSummary.topPerformingGoal.title,
  metricLocation: state.goalsSummary.topPerformingGoal.locationName,
  hidePercentChanged: true,
  showForecast: true,
  currentValPacing: state.goalsSummary.topPerformingGoal.currentValPacing,
  forecastValue: getForecastValue(state.goalsSummary.topPerformingGoal),
  value: getGoalValue(state.goalsSummary.topPerformingGoal),
  goalCurrentVal: state.goalsSummary.topPerformingGoal.currentVal,
  changeValue: 0.03,
  goalRemainValue:
    state.goalsSummary.topPerformingGoal.prevPeriodVal * (state.goalsSummary.topPerformingGoal.goalIncrease / 100) +
    state.goalsSummary.topPerformingGoal.prevPeriodVal -
    state.goalsSummary.topPerformingGoal.currentVal,
  currencySymbol: state.goalsSummary.topPerformingGoal.currencySymbol,
  currentUser: state.goalsSummary.currentUser,
  goalUsesPercent: state.goalsSummary.topPerformingGoal.goalUsesPercent,
  goalValue: state.goalsSummary.topPerformingGoal.goalValue
}))(DonutForecast);
